import Api from '@/services/Api'

export default {
  /*
  index (name, start, pageSize) {
    var results = Api().get('cemetery?name=' + name + "&start=" + start + "&limit=" + pageSize) ;
    console.log("In cemetery service back from server results=" + results) ;
    return results ;
  },
  */
  findMatchesOnName (cemeteryNameFragment, sortBy, start, pageSize) { // sortBy name/count
    console.log("In findMatchesOnName, cemeteryNameFragment=" + cemeteryNameFragment) ;
    var results =  Api().get('cemeteryFindMatchesOnName?cemeteryNameFrag=' +  cemeteryNameFragment +
      ((start) ? ("&start=" + start) : "") +
      ((pageSize) ? ("&limit=" + pageSize) : "") +
      ((sortBy) ? ("&sortBy=" + sortBy) : "")) ;
    console.log("Back in findMatchesOnName, results=" + results) ;
    return results ;
  },  
  id (cemeteryId) {
    console.log("in cemetery id = " + cemeteryId) ;
    var results = Api().get("cemetery/" + cemeteryId) ;
    console.log("Back from API GET UNIT ID") ;
    return results ; 
  },
  create (newCemetery) {
    console.log("in create cemetery") ;
    var results = Api().post('cemeteryCreate', newCemetery) ;
    console.log("after create, results=" + results) ;
    return results ;
  },
  edit (edittedCemetery) {
    var results = Api().post('cemeteryUpdate', edittedCemetery) ;
    console.log("after edit, results=" + results) ;
    return results ;
  },
  mergeTo (edittedCemetery) {
    console.log("in mergeTo serviced edittedcemetery=" + JSON.stringify(edittedCemetery)) ;    
    var results = Api().post('cemeteryMergeTo', edittedCemetery) ;
    console.log("after mergeTo, results=" + results) ;
    return results ;
  }
}



// WEBPACK FOOTER //
// ./src/services/CemeteryService.js